import sc from 'styled-components';

import React from 'react';
export default sc.article`
  overflow-x: auto;
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  `;
